import { BeatGhostPage } from './pages/BeatGhostPage';
import { RapidFireGame } from './pages/RapidFireGame';
import { SurvivalGame } from './pages/SurvivalGame';

export const learningRoutes = [
  {
    path: '/learning/rapid-fire',
    label: 'Rapid Fire',
    heading: 'Rapid Fire',
    Component: RapidFireGame,
  },
  {
    path: '/learning/survival',
    label: 'Survival',
    heading: 'Survival',
    Component: SurvivalGame,
  },
  {
    path: '/learning/ghost',
    label: 'Beat Your Ghost',
    heading: 'Race your personal best',
    Component: BeatGhostPage,
  },
] as const;
